export default __webpack_public_path__ + "static/media/conduitEdit3.1dda092a.jpg";